import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginRequest, loginSuccess, loginFailure } from '../redux/sessionSlice';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../css/መግቢያ.css';
import logo from '../assets/favicon.jpg';
import { Link } from 'react-router-dom';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const { loading, error } = useSelector((state) => state.session);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Dispatch loginRequest to indicate loading state
    dispatch(loginRequest());

    try {
      const response = await axios.post('http://127.0.0.1:8000/api/accounts/login/', {
        email: username, // Correct field name is 'email' based on the API
        password: password,
      });

      if (response.data.access) {
        dispatch(
          loginSuccess({
            user: response.data.user, // Store user details in Redux
            token: response.data.access,
          })
        );

        // Persist in localStorage (optional)
      localStorage.setItem("userSession", JSON.stringify({
        user: response.data.user,
        token: response.data.access,
      }));

      navigate("/dashboard");
      } else {
        // In case the API response doesn't contain a token or user data
        dispatch(loginFailure('Invalid credentials or server error.'));
      }

    } catch (error) {
      dispatch(loginFailure('Invalid credentials or server error.'));
      console.error('Login error:', error);
    }
  };

  return (
    <div className="login-container">
      <div className="back-home">
        <Link to="/" className="back-home-link">
          <span className="back-home-text">Back to Home</span>
        </Link>
      </div>
      <div className="login-card">
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <h2 className="login-title">Welcome Back</h2>
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              placeholder="Email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="input-field"
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field"
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="btn btn-custom" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
